import React from "react";
import { useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const AdminMenu = (props) => {
  const { t, handleNavItemClick, handleContextMenu } = props;
  const params = useParams();

  return (
    <div className="sub-list">
      <ul>
        <li
          data-link={`/administration/manager`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "manager" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_USERS")}
        </li>
        <li
          data-link={`/administration/translation`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "translation" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_TRANSLATIONS")}
        </li>

        <li
          data-link={`/administration/emails`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "emails" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_EMAILS_TEMPLATE")}
        </li>

        <li
          data-link={`/administration/transport`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "transport" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_TRANSPORT_TYPES")}
        </li>
        <li
          data-link={`/administration/mentiongroups`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "mentiongroups" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_DISCUSSION_GROUPS")}
        </li>
        <li
          data-link={`/administration/bankAccounts`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "bankAccounts" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_BANK_ACCOUNTS")}
        </li>
        <li
          data-link={`/administration/vatlists`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "vatlists" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_VAT_RATES")}
        </li>
        <li
          data-link={`/administration/paymentTerms`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "paymentTerms" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_PAYMENT_TERMS")}
        </li>
        <li
          data-link={`/administration/specificConditions`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "specificConditions" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_SPECIFIC_CONDITIONS")}
        </li>
        <li
          data-link={`/administration/products`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "products" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_PRODUCTS")}
        </li>
        <li
          data-link={`/administration/generalParameters`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "generalParameters" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_GENERAL_PARAMETERS")}
        </li>
        <li
          data-link={`/administration/clientUsers`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "clientUsers" ? "active" : ""}
        >
          {t("MENU_ADMINISTRATION_CLIENTS_USERS")}
        </li>
      </ul>
    </div>
  );
};

AdminMenu.propTypes = {
  t: PropTypes.func.isRequired,
  handleNavItemClick: PropTypes.func.isRequired,
  handleContextMenu: PropTypes.func.isRequired,
};

export default withTranslation()(AdminMenu);
